import { useQuery } from "@tanstack/react-query";

export type CommunityTalkCapabilities = {
  topicMetadataPersistence: boolean;
  mode: "compatibility" | "preview-persistent";
};

const FALLBACK_CAPABILITIES: CommunityTalkCapabilities = {
  topicMetadataPersistence: false,
  mode: "compatibility",
};

export function useCommunityTalkCapabilities() {
  const query = useQuery<CommunityTalkCapabilities>({
    queryKey: ["/api/community-talk/capabilities"],
    staleTime: 30_000,
  });

  return {
    ...query,
    capabilities: query.data ?? FALLBACK_CAPABILITIES,
  };
}
